import React, { useState, useEffect } from "react";
import "./style.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "../CtaButton";

const EngagmentModelScroller = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
    });
  }, []);

  const navigate = useNavigate();

  const [gradientPosition, setGradientPosition] = useState(53);

  useEffect(() => {
    const handleScroll = () => {
      // Calculate the new gradient position based on scroll position
      const scrollPosition = window.scrollY;
      const maxScroll =
        document.documentElement.scrollHeight - window.innerHeight;
      const newGradientPosition = Math.min(
        100,
        (scrollPosition / maxScroll) * 100
      ); // Map scroll position to a range of 0 to 100
      setGradientPosition(newGradientPosition);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const { t } = useTranslation("engagementModelPage");

  // Get translated projects array
  const engagementModalScroller = t("engagementModalScroller", {
    returnObjects: true,
  });

  return (
    <>
      <div className="engagment-model-scroller-box">
        <div className="container">
          <div className="row side-line-bar">
            <div className="col-lg-6 col-md-12 col-xl-6">
              <div className="engagment-model-scroller-leftbar sticy-bar-left">
                <h2 className="low-top-heading">One Size Engagement Model Does not Fit all</h2>
                <p
                  className="moving-gradient-heading"
                  style={{
                    "--gradient-position": `${gradientPosition}%`,
                  }}
                >
                  {engagementModalScroller.heading}
                </p>
                <p
                  className="common-text"
                  dangerouslySetInnerHTML={{ __html: engagementModalScroller.paragraphOne }}
                />
                <p
                  className="common-text"
                  dangerouslySetInnerHTML={{ __html: engagementModalScroller.paragraphTwo }}
                />
                <h4> {engagementModalScroller?.helpModelList?.heading}</h4>
                <ul>
                  {engagementModalScroller?.helpModelList?.list?.map((list, index) => {
                    return <li key={index}>{list}</li>
                  })}
                </ul>
                <h3 className="mt-2">{engagementModalScroller.subHeading}</h3>
                <p
                  className="common-text"
                  dangerouslySetInnerHTML={{ __html: engagementModalScroller.subContent }}
                />

                <Button
                  text={engagementModalScroller.iNeedThisButton}
                  link={"/contact-us"}
                  className="mt-3"
                />
              </div>
            </div>

            <div
              className="col-lg-6 col-md-12 col-xl-6 pl-lg-4 ps-xl-4"
              style={{ scrollBehavior: "smooth" }}
            >

              {/* <div className="engagement-model-models-content mb-4">
                <h2>{engagementModalScroller?.ModelsContent?.heading}</h2>
                <p
                  className="common-text"
                  dangerouslySetInnerHTML={{ __html: engagementModalScroller?.ModelsContent?.description }}
                />
              </div> */}

              {engagementModalScroller.scrollerData?.map((item, index) => {
                return (
                  <div
                    className="engagment-model-scroller-side"
                    key={index}
                    data-aos="fade-up"
                  >
                    <h3>{item?.title}</h3>
                    <p className="common-text" dangerouslySetInnerHTML={{ __html: item?.description }}></p>
                    <div className="engagment-model-scroller-leftbar">
                      <h4>{engagementModalScroller.benefits}</h4>
                      <ul>
                        {item?.benefits?.map((list, index) => {
                          return <li key={index}>{list}</li>;
                        })}
                      </ul>

                      <h4>{item.modelTitle}</h4>
                      <ul>
                        {item?.modelPoints?.map((modeList, index) => {
                          return <li key={index}>{modeList}</li>;
                        })}
                      </ul>
                    </div>
                    {/* <div className="engagement-model-bg-image-box">
                      <div className="engagment-mode-scroller-images">
                        <h3>{item?.modelTitle}</h3>
                        <ul>
                          {item?.modelPoints?.map((modeList, index) => {
                            return <li key={index}>{modeList}</li>;
                          })}
                        </ul>
                        <h3 className="mt-3">{item?.modelTitleTwo}</h3>
                        <ul>
                          {item?.modelPointsTwo?.map((modeList, index) => {
                            return <li key={index}>{modeList}</li>;
                          })}
                        </ul>
                      </div>
                    </div> */}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EngagmentModelScroller;
